/**
 * @fileoverview PUT handler for the "/engagement/report_dashboard/:dashboard_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportDashboardDashboardIdCacheKeys } from "./constants";
import type {
  PutEngagementReportDashboardDashboardIdProps,
  EngagementReportDashboardUpdateDashboardResult,
} from "./types";

export const putEngagementReportDashboardDashboardId = reactQueryMutationAdapter(
  engagementReportDashboardDashboardIdCacheKeys,
  (
    props: PutEngagementReportDashboardDashboardIdProps
  ): Promise<EngagementReportDashboardUpdateDashboardResult> => {
    return fetch(`/engagement/report_dashboard/${props.dashboardId}`, "PUT", props);
  }
);
